import {getId} from 'apis/model/base'
import _ from 'lodash'
import React from 'react'
import {renderSelf} from 'views/Shared'

export const CodiContentTypes = Object.freeze({
    ROOT: 'root',
    SUPER_PART: 'sup_part',
    PART: 'part',
    APPENDIX: 'appendix',
    CHAPTER: 'chapter',
    SECTION: 'section',
    ARTICLE: 'article',
    CLAUSE: 'clause',
    POINT: 'point',
    CONTENT: 'content',
    SENTENCE: 'sentence',
    PARAGRAPH: 'paragraph',
    SUB_SECTION: 'sub_section',
    SUPER_SECTION: 'sup_section',
    SUB_CHAPTER: 'sub_chapter',
    SUPER_CHAPTER: 'sup_chapter',
})

export const CodiActions = Object.freeze({
    SELECT_ROW: 'select-row',
    EDIT_CONTENT: 'edit-content',
    INSERT_CONTENT: 'insert-content',
    DELETE_CONTENT: 'delete-content',
    SELECT_SYSTEM_ROW: 'select-system-row',
    REARRANGE_CONTENT: 'rearrange-content',
    SET_SYSTEM_ROW: 'set-system-row',
    SHOW_INFO_MODAL: 'show-info-modal',
    SHOW_ADMIN_MODAL: 'show-admin-modal',
    SHOW_DETAIL_MODAL: 'show-detail-modal',
    SHOW_NOTES_MODAL: 'show-notes-modal',
    SHOW_LINKS_MODAL: 'show-links-modal',
    SHOW_SEARCH_MODAL: 'show-search-modal',
    SHOW_INDEXES_MODAL: 'show-indexes-modal',
    SHOW_KEYWORDS_MODAL: 'show-keywords-modal',
    UPDATE_CODI_ROW_TYPE: 'update-codi-row-type',
    SHOW_RELATED_CODI_MODAL: 'show-related-codi-modal',
    SHOW_BROS_CODI_MODAL: 'show-bros-codi-modal',
    SHOW_EDIT_CONTENT_MODAL: 'show-edit-content-modal',
    SHOW_UPDATE_ROW_TYPE_MODAL: 'update-row-type-modal',
    SHOW_INSERT_CONTENT_MODAL: 'show-insert-content-modal',
    SHOW_RELATED_ARTICLES_MODAL: 'show-related-articles-modal',
    SHOW_REARRANGE_CONTENT_MODAL: 'show-rearrange-content-modal',
})

export const flatten_rows = (row, name) =>
    _.flatMap([
        ...(_.get(row, name) ?? []),
        ...Array.from(row?.children_rows ?? []).map((item) =>
            flatten_rows(item, name)
        ),
    ])

export function getInnerContentTypes(index_typecd) {
    let options = []
    switch (index_typecd) {
        case CodiContentTypes.ROOT:
            options = [
                CodiContentTypes.PART,
                CodiContentTypes.SUPER_PART,
                CodiContentTypes.APPENDIX,
                CodiContentTypes.SUB_CHAPTER,
                CodiContentTypes.CHAPTER,
                CodiContentTypes.SUPER_CHAPTER,
                CodiContentTypes.ARTICLE,
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        case CodiContentTypes.PART:
        case CodiContentTypes.SUPER_PART:
        case CodiContentTypes.APPENDIX:
            options = [
                CodiContentTypes.SUB_CHAPTER,
                CodiContentTypes.CHAPTER,
                CodiContentTypes.SUPER_CHAPTER,
                CodiContentTypes.ARTICLE,
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        case CodiContentTypes.SUB_CHAPTER:
        case CodiContentTypes.SUPER_CHAPTER:
        case CodiContentTypes.CHAPTER:
            options = [
                CodiContentTypes.SUB_SECTION,
                CodiContentTypes.SECTION,
                CodiContentTypes.SUPER_SECTION,
                CodiContentTypes.ARTICLE,
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        case CodiContentTypes.SUB_SECTION:
        case CodiContentTypes.SECTION:
        case CodiContentTypes.SUPER_SECTION:
            options = [
                CodiContentTypes.ARTICLE,
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        case CodiContentTypes.ARTICLE:
            options = [
                CodiContentTypes.CLAUSE,
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        case CodiContentTypes.CLAUSE:
            options = [
                CodiContentTypes.POINT,
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        case CodiContentTypes.POINT:
            options = [
                CodiContentTypes.CONTENT,
                CodiContentTypes.PARAGRAPH,
                CodiContentTypes.SENTENCE,
            ]
            break
        default:
            break
    }
    return options
}

export function getRowTitle({item, translate = renderSelf}) {
    let title;
    let separator = '.';
    const {index_cd, content, index_typecd} = item ?? {}
    switch (index_typecd) {
        case CodiContentTypes.ROOT:
            return `${index_cd ? `${index_cd}: ` : ''}${content}`
        case CodiContentTypes.SUPER_PART:
        case CodiContentTypes.PART:
        case CodiContentTypes.APPENDIX:
        case CodiContentTypes.SUPER_CHAPTER:
        case CodiContentTypes.SUPER_SECTION:
        case CodiContentTypes.CHAPTER:
        case CodiContentTypes.SECTION:
        case CodiContentTypes.SUB_CHAPTER:
        case CodiContentTypes.SUB_SECTION:
        case CodiContentTypes.ARTICLE:
            separator = ':';
            title = index_cd;
            break;
        case CodiContentTypes.CLAUSE:
        case CodiContentTypes.POINT:
            separator = '.';
            title = index_cd;
            break;
        case CodiContentTypes.PARAGRAPH:
        case CodiContentTypes.SENTENCE:
        case CodiContentTypes.CONTENT:
        default:
            separator = '';
            title = index_cd;
            break
    }
    if (_.isEmpty(title)) {
        return content
    } else if (_.isEmpty(content)) {
        return title
    }
    return `${title}${separator} ${content}`
}

export function getLinkToDetailRow(item) {
    const {codi_document_page, codi_document} = item ?? {}
    // const { codi_document } = codi_document_page ?? {}
    const page_id = codi_document_page?.id
    const detail_id = item?.id
    const ref_detail_id = item?.ref_id
    let searchParams = new URLSearchParams()
    if (page_id) {
        searchParams.set('row', page_id)
        if (detail_id && detail_id !== page_id) {
            searchParams.set('detail_id', detail_id)
            searchParams.set('ref_detail_id', ref_detail_id)
        } else {
            searchParams.delete('detail_id')
            searchParams.delete('ref_detail_id')
        }
        return _.omitBy(
            {
                search: '?' + searchParams.toString(),
                pathname: '/book/:id'.replace(':id', getId(codi_document)),
            },
            _.isUndefined,
        )
    }
    return null
}

